// Originals-presence rule: a NEW copy/ISCI (Cadent has no DH master for it)
// must carry at least one original ISCI, otherwise the backend submits a
// Vantage transcode with no source files. Traffic-only and EXISTING spots are
// exempt — including EXISTING spots with no stored DH originals
// (allow_manual_originals), whose only downside is "TBD" brand on the PDF.
// The backend enforces the same rule in distrohub/use_cases/brs/create.py
// (validate_originals_present).

export const spotIsNew = (spot) =>
  spot.traffic_only !== true && spot.isciasset?.exists === false;

// The original_iscis array is seeded with empty rows, so presence is judged
// by content — the same predicate buildPayload uses to filter rows.
export const hasOriginals = (spot) =>
  (spot.isciasset?.original_iscis || []).some((oi) => oi && oi.isci);

export const validateOriginalsPresent = (spots) => {
  for (let i = 0; i < spots.length; i++) {
    if (spotIsNew(spots[i]) && !hasOriginals(spots[i])) {
      return `Spot ${i + 1}: at least one Original ISCI (DH Master) is required`;
    }
  }
  return null;
};
